// types
import {
  USER_SET_ROLE,
  USER_SET_FLOW,
  USER_SET_FLOW_HAS_IMAGES,
  USER_SET_FLOW_STATE,
  USER_SET_MANAGE_DAMAGE_APPOINTMENT_FLOW_RESULT,
  USER_SET_MANAGE_DAMAGE_BILLMA_FLOW_RESULT, USER_SET_ID
} from './types'

export default {
  [USER_SET_ROLE] ({ commit }, payload) {
    commit(USER_SET_ROLE, payload)
  },
  [USER_SET_ID] ({ commit }, payload) {
    commit(USER_SET_ID, payload)
  },
  [USER_SET_FLOW] ({ commit }, payload) {
    commit(USER_SET_FLOW, payload)
  },
  [USER_SET_FLOW_HAS_IMAGES] ({ commit }, payload) {
    commit(USER_SET_FLOW_HAS_IMAGES, payload)
  },
  [USER_SET_FLOW_STATE] ({ commit }, payload) {
    commit(USER_SET_FLOW_STATE, payload)
  },
  [USER_SET_MANAGE_DAMAGE_APPOINTMENT_FLOW_RESULT] ({ commit }, payload) {
    commit(USER_SET_MANAGE_DAMAGE_APPOINTMENT_FLOW_RESULT, payload)
  },
  [USER_SET_MANAGE_DAMAGE_BILLMA_FLOW_RESULT] ({ commit }, payload) {
    commit(USER_SET_MANAGE_DAMAGE_BILLMA_FLOW_RESULT, payload)
  }
}
